import { useState } from "react";
import { Phone, ChevronDown, ChevronUp } from "lucide-react";
import { PREVENTION_TEXT } from "../../config/site";

const KEY = "prevention_bar_collapsed";

export default function PreventionBar() {
  const [collapsed, setCollapsed] = useState(
    () => sessionStorage.getItem(KEY) === "1",
  );

  const toggle = (value) => {
    setCollapsed(value);
    sessionStorage.setItem(KEY, value ? "1" : "0");
    window.dispatchEvent(new Event("prevention-bar-toggle"));
  };

  if (collapsed) {
    return (
      <button
        type="button"
        data-testid="prevention-bar-expand"
        onClick={() => toggle(false)}
        className="fixed bottom-0 left-0 right-0 z-40 flex items-center justify-center gap-2 border-t border-[#E8A317] bg-[#0B1F3A] py-1.5 text-xs font-medium text-white/80 transition-colors hover:text-white"
        aria-label="Afficher le message de prévention"
      >
        <Phone className="h-3 w-3" aria-hidden="true" />
        Prévention : 09 74 75 13 13
        <ChevronUp className="h-3 w-3" aria-hidden="true" />
      </button>
    );
  }

  return (
    <div
      data-testid="prevention-bar"
      role="contentinfo"
      className="fixed bottom-0 left-0 right-0 z-40 border-t-2 border-[#E8A317] bg-[#0B1F3A] px-4 py-2.5 text-white"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3">
        <p className="text-xs font-medium leading-snug sm:text-sm">
          <Phone className="mr-1.5 inline h-3.5 w-3.5 text-[#E8A317]" aria-hidden="true" />
          {PREVENTION_TEXT}
        </p>
        <button
          type="button"
          data-testid="prevention-bar-collapse"
          onClick={() => toggle(true)}
          aria-label="Replier le message de prévention"
          className="shrink-0 rounded-md p-1.5 text-white/70 transition-colors hover:bg-white/10 hover:text-white"
        >
          <ChevronDown className="h-4 w-4" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
